import React from 'react'
import { TrendingUp, TrendingDown } from 'lucide-react'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'success' | 'danger' | 'warning' | 'neutral' | 'muted'
  size?: 'sm' | 'md'
  showTrend?: boolean
  trendDirection?: 'up' | 'down'
  className?: string
}

export function Badge({ 
  children, 
  variant = 'neutral', 
  size = 'sm',
  showTrend = false,
  trendDirection,
  className = '' 
}: BadgeProps) {
  
  const getVariantClasses = (variant: string) => {
    switch (variant) {
      case 'success':
        return 'bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20'
      case 'danger':
        return 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20'
      case 'warning':
        return 'bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20'
      case 'neutral':
        return 'bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20'
      case 'muted':
        return 'bg-muted/50 text-muted-foreground border-border/50'
      default:
        return 'bg-muted/50 text-muted-foreground border-border/50'
    }
  }

  const getSizeClasses = (size: string) => {
    switch (size) {
      case 'md':
        return 'px-3 py-1.5 text-sm'
      default:
        return 'px-2 py-1 text-xs'
    }
  }

  const TrendIcon = trendDirection === 'up' ? TrendingUp : TrendingDown

  return (
    <div className={`
      inline-flex items-center space-x-1 rounded-full border font-medium
      ${getVariantClasses(variant)}
      ${getSizeClasses(size)}
      ${className}
    `}>
      {showTrend && trendDirection && (
        <TrendIcon className="w-3 h-3" />
      )}
      <span>{children}</span>
    </div>
  )
}

export default Badge
